"use strict";
export function parseERC20ApproveCalldata(data) {
  const amount = BigInt(`0x${data.slice(-64)}`);
  const spender = `0x${data.slice(-104, -64)}`;
  return { amount, spender };
}
